export const paginationSizeOptions = [5, 10, 25, 50];

export const sortDirections = ['ascend', 'descend'];

export const defDelPopConf = {
  title: `Delete the record`,
  desc: `Are you sure to delete this record?`,
};
